<div class="row footer-wrapper">
    <img class="" src="/assets/img/footer_img.png" alt="Galeeriano">
</div>
